import React, { useLayoutEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './index.css';
import App from './App';
import LeadPage from './LeadPage';
import CaseStudiesIndex from './CaseStudiesIndex';
import CaseStudyDrJim from './CaseStudyDrJim';
import CalculatorPage from './CalculatorPage';
import reportWebVitals from './reportWebVitals';

function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (!hash) return;
    const element = document.getElementById(hash.slice(1));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [pathname, hash]);

  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToHash />
      <Routes>
        <Route path='/' element={<App />} />
        <Route path='/consultation' element={<LeadPage />} />
        <Route path='/calculator' element={<CalculatorPage />} />
        <Route path='/case-studies' element={<CaseStudiesIndex />} />
        <Route path='/case-studies/pathology-billing-modifier-accuracy' element={<CaseStudyDrJim />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
